import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCQueenMoleworm extends NPC {
    constructor() {
        super(definitions.NPC_ID.QUEEN_MOLEWORM);

        this.collisionRadius = 120;
        this.collisionOffsetX = 100;
        this.collisionOffsetY = -30;
        this.interactionRadius = 550;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_queen_moleworm_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(8, -12));
        this.animateIdle(1);
    } 

    onViewAdded() {
        super.onViewAdded();

        this.status.x += 270;
        this.status.y += 200;
    }
}